import moment from 'moment'

moment.locale('es')

class RankingFilterService {
  static getFilters (params) {
    let filters = {
      from: this.getStorageStartDate(),
      to: this.getStorageFinishDate(),
      lesson: this.getStorageLesson()
    }
    if (params) {
      if (params.from && this.isValidDate(params.from)) {
        filters.from = moment(params.from, 'YYYY-MM-DD').toDate()
      }
      if (params.to && this.isValidDate(params.to)) {
        filters.to = moment(params.to, 'YYYY-MM-DD').toDate()
      }
      if (params.lesson && Number.isInteger(parseInt(params.lesson))) {
        filters.lesson = parseInt(params.lesson)
      }
    }
    return filters
  }

  static setStorageFilters (filters) {
    let data = {
      'lastSave': moment().format('YYYY-MM-DD'),
      ...filters
    }
    localStorage.setItem('dashboarFilters', JSON.stringify(data))
  }

  static isValidDate (date) {
    return moment(date, 'YYYY-MM-DD').isValid()
  }

  static getStorageFilters () {
    let filters = JSON.parse(localStorage.getItem('dashboarFilters'))
    let currentDay = moment().format('YYYY-MM-DD')
    return !filters || filters.lastSave !== currentDay ? null : filters
  }

  static getStorageStartDate () {
    let filters = this.getStorageFilters()
    return filters && filters.from ? moment(filters.from, 'YYYY-MM-DD').toDate() : moment().subtract(6, 'months').toDate()
  }

  static getStorageFinishDate () {
    let filters = this.getStorageFilters()
    return filters && filters.to ? moment(filters.to, 'YYYY-MM-DD').toDate() : moment().toDate()
  }

  static getStorageLesson () {
    let filters = this.getStorageFilters()
    return filters && filters.lesson ? filters.lesson : 0
  }
}

export default RankingFilterService
